import React from 'react';
import './PackageCard.css';
import { useTranslation } from 'react-i18next';

const PackageCard = ({ 
  id, 
  tokens, 
  price, 
  originalPrice, 
  purchase,
  onPurchase = true,
  fullWidth = false
}) => {
  const { t } = useTranslation();

  const handleFormatPrice = (price) => {
    return Intl.NumberFormat(
      'en-US', { 
        style: 'currency', 
        currency: 'USD', 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2, 
        useGrouping: true 
      }).format(price);
  };

  return (
      <div className="package-card" style={{ width: fullWidth ? '250px' : '130px' }}>
          <div className="tokens">{tokens.toLocaleString('en-US')} barter Bucks</div>
          <div className="price">
              <span className="current-price">{handleFormatPrice(price)}</span>
              {originalPrice ? (
                  <span className="original-price">{handleFormatPrice(originalPrice)}</span>
              ) : (
                <span className="original-price-empty"></span>
              )}
          </div>
          {onPurchase && (
            <button className="buy-button" onClick={() => purchase(id)}>{t('packages.buy')}</button>
          )}
      </div>
  );
};

export default PackageCard;
